import { Link } from "react-router-dom";
import Layout from "./Layout";

export function AuthShell({ title, subtitle, children }) {
  return (
    <Layout>
      <div className="min-h-[70vh] flex items-center justify-center px-5 py-16">
        <div className="w-full max-w-md bg-[#0A0A0A] border border-white/10 rounded-2xl p-8 sm:p-10 nh-fade-up">
          <Link to="/" className="font-mono font-extrabold text-lg block mb-6">
            NAŠA<span className="text-nhgreen text-glow-green">HUB</span>
          </Link>
          <h1 className="font-mono font-bold text-2xl">{title}</h1>
          {subtitle && <p className="text-white/50 text-sm mt-3">{subtitle}</p>}
          <div className="mt-7">{children}</div>
        </div>
      </div>
    </Layout>
  );
}

export function Field({ label, testid, ...props }) {
  return (
    <label className="block mb-4">
      <span className="font-mono text-xs tracking-widest uppercase text-white/50">{label}</span>
      <input
        data-testid={testid}
        className="mt-2 w-full bg-[#111111] border border-white/20 text-white rounded-md px-4 py-3 text-sm outline-none focus:border-nhgreen focus:ring-1 focus:ring-nhgreen transition-colors"
        {...props}
      />
    </label>
  );
}

export function SubmitBtn({ children, loading, testid }) {
  return (
    <button
      type="submit"
      data-testid={testid}
      disabled={loading}
      className="w-full font-mono font-bold text-sm bg-nhgreen text-black rounded-md py-3 hover:bg-[#1ee068] hover:shadow-[0_0_15px_rgba(34,255,119,0.4)] transition-[background-color,box-shadow] duration-200 disabled:opacity-50"
    >
      {loading ? "..." : children}
    </button>
  );
}
